import { Grid } from "@mui/material";
import TemplateDashboard from "./TemplateDashboard";
import { MenusProps } from "../Menus";
import TemplateOpcoes from "./TemplateOpcoes";
import AddIcon from '@mui/icons-material/Add';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';

export default function TemplateOpcoesBasicas({
    type,
    textColor,
    gridCol = { md: 2.4 },
    opcoesBasic = true
}: TemplateOpcoesBasicasProps) {

    return (
        <Grid container spacing={2} alignSelf="flex-start" {...gridCol}>
            <Grid size={{xs:12}}>
                <TemplateDashboard {...{ type }} color={textColor} />
            </Grid>

            {
                opcoesBasic &&
                <Grid size={{xs:12}}>
                    <TemplateOpcoes
                        title="Cooperados"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => { },
                                disabled: true
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => { },
                                disabled: true
                            },
                        ]}
                    />

                    <TemplateOpcoes
                        title="Clientes"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => { },
                                disabled: true
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => { },
                                disabled: true
                            },
                        ]}
                    />

                    <TemplateOpcoes
                        title="Fornecedores"
                        color={textColor}
                        items={[
                            {
                                label: "Incluir",
                                icon: <AddIcon fontSize="inherit" />,
                                action: () => { },
                                disabled: true
                            },
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => { },
                                disabled: true
                            },
                        ]}
                    />
                </Grid>
            }
        </Grid>
    )
}

interface TemplateOpcoesBasicasProps extends MenusProps {
    textColor: string
    gridCol?: {
        xs?: number,
        md?: number,
        lg?: number
    },
    opcoesBasic?: boolean
}